import angular from 'angular';
import { getAngularServiceOrUndefined } from '../../core/helpers';
import { AngularMethods, AngularServices, angularServicesIntegration, } from './integration-types';
//integrate services from angular
export function applyAngularServicesIntegrations() {
    angular.element(document).ready(function () {
        const communicationControl = getAngularServiceOrUndefined(AngularServices.COMMUNICATION_CONTROL);
        const globalUi = getAngularServiceOrUndefined(AngularServices.GLOBAL_UI);
        const trackingFactory = getAngularServiceOrUndefined(AngularServices.TRACKING_FACTORY);
        const roomHelpersFactory = getAngularServiceOrUndefined(AngularServices.ROOM_HELPERS_FACTORY);
        const VideoProviderFactory = getAngularServiceOrUndefined(AngularServices.VIDEO_PROVIDER_FACTORY);
        const publisherManager = getAngularServiceOrUndefined(AngularServices.PUBLISHER_MANAGER);
        if (communicationControl) {
            angularServicesIntegration.set(AngularMethods.ADD_PERSON_TO_GROUP_CALL_BY_UID, communicationControl[AngularMethods.ADD_PERSON_TO_GROUP_CALL_BY_UID].bind(communicationControl));
        }
        if (globalUi) {
            angularServicesIntegration.set(AngularServices.GLOBAL_UI, globalUi[AngularMethods.UI]);
        }
        if (trackingFactory) {
            angularServicesIntegration.set(AngularMethods.GLOBAL_TRACKING, trackingFactory.global);
        }
        if (roomHelpersFactory) {
            angularServicesIntegration.set(AngularMethods.GET_ROOM, roomHelpersFactory[AngularMethods.GET_ROOM]);
            angularServicesIntegration.set(AngularMethods.GET_ROOM_URL, roomHelpersFactory[AngularMethods.GET_ROOM_URL]);
        }
        if (Boolean(VideoProviderFactory)) {
            angularServicesIntegration.set(AngularServices.VIDEO_PROVIDER_FACTORY, VideoProviderFactory);
        }
        if (publisherManager) {
            angularServicesIntegration.set(AngularMethods.B64_TO_BLOB, publisherManager[AngularMethods.B64_TO_BLOB]);
        }
    });
}
